import Vue from 'vue'

import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import Element from 'element-ui'
// ElementUI.Dialog.props.closeOnClickModal.default = false
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import '@/assets/img/iconfont.css' // 引入iconfont
import '@/assets/styles/style.scss';
// import JsonExcel from 'vue-json-excel'
import Print from 'vue-print-nb'; // 打印插件
import App from './App'
import store from './store'
import router from './router'
import directive from './directive' //directive
import plugins from './plugins' // plugins
import {
  download,
  downloadResp
} from '@/utils/request'

import './assets/icons' // icon
import './permission' // permission control
import {
  getDicts
} from "@/api/system/dict/data";
import {
  getConfigKey
} from "@/api/system/config";
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree
} from "@/utils/ruoyi";
// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar"
// 富文本组件
import Editor from "@/components/Editor"
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 字典标签组件
import DictTag from '@/components/DictTag'
// 头部标签组件
import VueMeta from 'vue-meta'
// 字典数据组件
import DictData from '@/components/DictData'
// import BaiduMap from 'vue-baidu-map'
// import map from './components/map'
// 图标组件
import VCharts from 'v-charts'
import echarts from "echarts";
// 地图测距
// import distanceTool from './components/distanceTool'
// import BmlMarkerClusterer from './components/BmlMarkerClusterer'
// import video from './components/BmlMarkerClusterer'
import dataV from '@jiaminghi/data-view' // dataV
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";
// 引入睡眠服务
import {
  sleep
} from '@/utils/sleep';
// 导出组件
import JsonExcel from 'vue-json-excel'
import elDragDialog from '@/utils/elDragDialog' // 引入移动事件（el-drag-dialog.js的内容为上面的代码块）

import AFTableColumn from 'af-table-column'

Vue.directive('el-drag-dialog', elDragDialog); //添加标签事件绑定 可以放大移动弹窗
Vue.use(AFTableColumn)

Vue.use(VueEasytable);
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.downloadResp = downloadResp
Vue.prototype.handleTree = handleTree
Vue.prototype.$echarts = echarts
Vue.prototype.sleep = sleep

// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Editor', Editor)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('downloadExcel', JsonExcel)

Vue.use(directive)
Vue.use(plugins)
Vue.use(Print)
Vue.use(VCharts)
Vue.use(dataV)
Vue.use(VueMeta)
DictData.install()
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: '6zZoq4Lp7kgSl7oimp5W9PslbDGkgVEy'
// })
// Vue.use(map)
// Vue.use(TextIconOverlay)
// Vue.use(BmlMarkerClusterer)
// Vue.use(distanceTool)
// 百度地图key

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
